/**
 * 库管
 */
const TubeRouter = {
  path: '/tube',
  component: () => import('@/views/layout'),
  redirect: '/administration/purchase/list',
  hidden: true,
  meta: {
    title: 'desc'
  },
  children: [{
    path: '/administration/warehouse/out_info',
    name: 'outInfo',
    component: () => import('@/views/administration_manage/warehouse_manage/stock/out_info'),
    hidden: true,
    meta: {
      title: '出库'
    }
  },
  {
    path: '/administration/warehouse/isWarehouse/:id/:type',
    // type:1//1出库 2入库
    name: 'isWarehouse',
    component: () => import('@/views/administration_manage/warehouse_manage/is_warehouse'),
    hidden: true,
    meta: {
      title: '详情'// 出入库详情
    }
  },
  {
    path: '/administration/warehouse/recordList',

    name: 'recordList',
    component: () => import('@/views/administration_manage/warehouse_manage/stock/recordList'),
    hidden: true,
    meta: {
      title: '盘点记录'// 盘点记录
    }
  },
  {
    path: '/administration/warehouse/diffDetails/:id',
    name: 'diffDetails',
    component: () => import('@/views/administration_manage/warehouse_manage/stock/diff_details'),
    hidden: true,
    meta: {
      title: '详情'// 库存详情
    }
  },

  {
    path: '/administration/warehouse/allotmentInfo/:id',
    name: 'allotmentInfo',
    component: () => import('@/views/administration_manage/warehouse_manage/projectexist/allotment_info'),
    hidden: true,
    meta: {
      title: '详情'// 项目现存 配发详情
    }
  },
  {
    path: '/administration/warehouse/handoverInfo/:id/:type',
    name: 'handoverInfo',
    component: () => import('@/views/administration_manage/warehouse_manage/projectexist/handover_info'),
    hidden: true,
    meta: {
      title: '详情'// 项目现存 交接详情
    }
  },
  {
    path: '/administration/warehouse/equipInfo/:id/:type',
    name: 'equipInfo',
    component: () => import('@/views/administration_manage/warehouse_manage/projectexist/equip_info'),
    hidden: true,
    meta: {
      title: '装备详情'// 项目现存 交接详情
    }
  },
  {
    path: '/administration/assets/scrapInfo/:id',
    name: 'scrapInfo',
    component: () => import('@/views/administration_manage/assets_manage/scrap_info'),
    hidden: true,
    meta: {
      title: '详情'// 固定资产
    }
  },
  {
    path: '/administration/assets/add_scrap',
    name: 'addScrap',
    component: () => import('@/views/administration_manage/assets_manage/add_scrap'),
    hidden: true,
    meta: {
      title: '新增资产'// 固定资产
    }

  }

  ]
}

export default TubeRouter
